import Vue from 'vue'
import store from './store/api'
import VueRouter from 'vue-router'
import BootstrapVue from 'bootstrap-vue'
import * as VueGoogleMaps from 'vue2-google-maps'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'hover.css/css/hover-min.css'
import LangFlag from 'vue-lang-code-flags'
import App from './App.vue'
import Start from '@/components/Start.vue'
import Specs from '@/components/Specs.vue'
import Spec from '@/components/Spec.vue'
import Team from '@/components/Team.vue'
import TeamMember from '@/components/TeamMember.vue'
import NewsList from '@/components/NewsList.vue'
import News from '@/components/News.vue'
import Page from '@/components/Page.vue'
import Page2 from '@/components/Page2.vue'
import Contact from '@/components/Contact.vue'
import ContactForm from '@/components/ContactForm.vue'
import Loading from '@/components/Loading.vue'
import NotFound from '@/components/NotFound.vue'
import { HalfCircleSpinner } from 'epic-spinners'



import { library } from '@fortawesome/fontawesome-svg-core'
import { faArrowRight, faBars, faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faArrowRight, faBars, faArrowLeft)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('lang-flag', LangFlag)
Vue.component('loading-screen', Loading)
Vue.component('contact-form', ContactForm)
Vue.use(VueRouter)
Vue.component('spinner', HalfCircleSpinner)
Vue.use(BootstrapVue)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAS1Z6jrhim6OHT4XL_MzH10LEwI28Ilfc',
  },
})
Vue.config.productionTip = false

const router = new VueRouter({
  isLoading: true,
  mode: 'history',
  base: __dirname,
  routes: [
    { path: '/', component: Start, name: 'Start'},
    { path: '/specjalizacje', component: Specs, name: 'Specjalizacje' },
    { path: '/specjalizacje/:name', component: Spec, name: 'Specjalizacja' },
    { path: '/zespol', component: Team, name: 'Zespol' },
    { path: '/zespol/:name', component: TeamMember, name: 'CzlonekZespolu' },   
    { path: '/aktualnosci', component: NewsList, name: 'Aktualnosci'},    
    { path: '/aktualnosci/:name', component: News, name: 'Aktualnosc' },    
    { path: '/kariera', component: Page, name: 'Kariera' },    
    { path: '/kontakt', component: Contact, name: 'Kontakt' },
    { path: '/rodo', component: Page2, name: 'Polityka ochrony danych osobowych' },
    { path: '/404', component: NotFound, name: '404'},
    { path: '*', redirect: '/404'},
  ]
})

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
